<template>
  <div class="grid-filters" style="content-visibility: auto;">
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=0" class-name="grid-filters__item">#</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=a" class-name="grid-filters__item">A</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=b" class-name="grid-filters__item">B</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=c" class-name="grid-filters__item">C</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=d" class-name="grid-filters__item">D</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=r" class-name="grid-filters__item">E</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=f" class-name="grid-filters__item">F</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=g" class-name="grid-filters__item">G</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=h" class-name="grid-filters__item">H</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=i" class-name="grid-filters__item">I</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=j" class-name="grid-filters__item">J</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=k" class-name="grid-filters__item">K</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=l" class-name="grid-filters__item">L</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=m" class-name="grid-filters__item">M</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=n" class-name="grid-filters__item">N</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=o" class-name="grid-filters__item">O</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=p" class-name="grid-filters__item">P</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=q" class-name="grid-filters__item">Q</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=r" class-name="grid-filters__item">R</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=s" class-name="grid-filters__item">S</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=t" class-name="grid-filters__item">T</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=u" class-name="grid-filters__item">U</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=v" class-name="grid-filters__item">V</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=w" class-name="grid-filters__item">W</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=x" class-name="grid-filters__item">X</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=y" class-name="grid-filters__item">Y</Anchor>
    </div>
    <div class="grid-filters__cell">
      <Anchor href="/magazines/view-all?t=z" class-name="grid-filters__item">Z</Anchor>
    </div>
    <!-- <div v-for="(filter, index) in filters" :key="index" class="grid-filters__cell">
        <Anchor :href="`/magazines/view-all?t=${filter.key}`" classModel="grid-filters__item">{{ filter.key === '0' ? '#' : filter.key.toUpperCase() }}</Anchor>
      </div> -->
  </div>
</template>

<script>
export default {
  name: 'HeaderBottomFilter',
  serverCacheKey: props => `HeaderBottomFilter`,
  data() {
    return {
      // filters: [
      //   { key: '0' },
      //   { key: 'a' },
      //   { key: 'b' },
      //   { key: 'c' },
      //   { key: 'd' },
      //   { key: 'e' },
      //   { key: 'f' },
      //   { key: 'g' },
      //   { key: 'h' },
      //   { key: 'i' },
      //   { key: 'j' },
      //   { key: 'k' },
      //   { key: 'l' },
      //   { key: 'm' },
      //   { key: 'n' },
      //   { key: 'o' },
      //   { key: 'p' },
      //   { key: 'q' },
      //   { key: 'r' },
      //   { key: 's' },
      //   { key: 't' },
      //   { key: 'u' },
      //   { key: 'v' },
      //   { key: 'w' },
      //   { key: 'x' },
      //   { key: 'y' },
      //   { key: 'z' }
      // ]
    }
  }
}
</script>

<style lang="scss">
.grid-filters {
  content-visibility: auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 28px 14px;
  &__cell {
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: stretch;
    padding: 0px;
    &:before {
      content: '';
      display: table;
      padding-top: 100%;
    }
    &:hover {
      background-color: #ededed;
    }
  }
  &__item {
    flex-grow: 1;
    border: 0px solid $navLinkColor;
    color: $navLinkColor;

    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      color: $navLinkColor;
    }
  }
}
.grid-filters__cell {
  flex: 0 0 28px;
}

@media (max-width: $screen-md-min) {
  .grid-filters {
    min-width: unset;
    padding: 1px;
  }
}

@media (max-width: $screen-xs-max) {
  .grid-filters {
    display: none;
  }
}
</style>
